import { BusinessCompleteSolutionsActions } from "./types";

export const getBusinessCompleteSolutions =
  (): BusinessCompleteSolutionsActions => ({
    type: "REQUEST_BUSINESS_COMPLETE_SOLUTIONS_DATA",
  });

export const getBusinessCompleteSolutionsFailed =
  (): BusinessCompleteSolutionsActions => ({
    type: "REQUEST_BUSINESS_COMPLETE_SOLUTIONS_FAILED",
  });

export const getBusinessCompleteSolutionsSuccess = (
  payload
): BusinessCompleteSolutionsActions => ({
  type: "REQUEST_BUSINESS_COMPLETE_SOLUTIONS_SUCCESS",
  payload,
});
